export default __webpack_public_path__ + "static/media/stanthony.c89ee402.jpg";